import { render, staticRenderFns } from "./basicCard.vue?vue&type=template&id=cf9b8bb2&scoped=true"
import script from "./basicCard.vue?vue&type=script&lang=js"
export * from "./basicCard.vue?vue&type=script&lang=js"
import style0 from "./basicCard.vue?vue&type=style&index=0&id=cf9b8bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9b8bb2",
  null
  
)

export default component.exports